import React, { useState, useEffect } from 'react'
import firebase from '../../services/firebase';
import './search.css'

export default function BoxList ({ setSearch }) {

	const[searchType, setSearchType] = useState('name');	
	const[users, setUsers] = useState([]);
	const[timeOutSearch, setTimeOutSearch] = useState(null);

	useEffect(() => {
		// Get all users
		firebase.database.ref('users').once('value', snapshot => {
			setUsers(snapshot.val());
		})
	}, []);


// for (const property in users) {
// 	console.log(`${property}`);
// }

	const handleSearch = e => {
		const search = e.target.value;

		if(search.trim().length < 3) return setSearch([]);

		clearTimeout(timeOutSearch);
		
		setTimeOutSearch(
			setTimeout(() => {
				let result = [];

				for (const property in users) {
					if (users.hasOwnProperty(property)) {
						// Search by name
						if(searchType === 'name' && users[property].name.toUpperCase().match(search.trim().toUpperCase()) !== null) {
							let res = users[property]
							res['uid'] = `${property}`
							result.push(res);
						}

						// Search by technologies
						if(searchType === 'tech') {
							let hasTech = false;
							
							if(!users[property].techs) continue;

							users[property].techs.map(tech => {
								if(tech.toUpperCase() === search.trim().toUpperCase())
									hasTech = true;

								return true
							});

							if(hasTech) {
								let res = users[property]
								res['uid'] = `${property}`
								result.push(res);
							}
						}

						// Search by city
						if(searchType === 'city' && users[property].city) {
							if(users[property].city.toUpperCase().match(search.trim().toUpperCase())!== null){
								let res = users[property]
								res['uid'] = `${property}`
								result.push(res);
							}
						}
					}
				}

				setSearch(result);
			}, 500)
		);
		
	};

  return (
    <div className='search'>
			<div className="input-group">
  			<input
					type="text"
					className="form-control gray_clr"
					placeholder="pesquisar usuários por..."
					onChange={e => handleSearch(e)}
				/>
  		</div>
  		<div className="standard_primary_bg search-filter d-flex justify-content-around">

  			<div className="options d-flex justify-content-center align-items-center options bg-yellow">
        	<input className='form-check-input'
        		type='radio'
        		id="name"
        		name="searching"
						value="name"
						onChange={e => setSearchType(e.target.value)}
        		defaultChecked
        		/>
        	<label className='form-check-label weight-bold white_clr' htmlFor='name'>Nome</label>
        </div>

         <div className="options d-flex justify-content-center align-items-center options">
        	<input className='form-check-input'
        		type='radio'
        		id="tech"
        		name="searching"
        		value="tech"
						onChange={e => setSearchType(e.target.value)}
					/>
        	<label className='form-check-label weight-bold white_clr' htmlFor='tech'>Tecnologia</label>
        </div>

         <div className="options d-flex justify-content-center align-items-center options">
        	<input className='form-check-input'
        		type='radio'
        		id="city"
        		name="searching"
						value="city"
						onChange={e => setSearchType(e.target.value)}
					/>
        	<label className='form-check-label weight-bold white_clr' htmlFor='city'>Cidade</label>
        </div>
  		</div>
  	</div>
  )
}